import { Routes } from "@angular/router";
import { QrCodeViewerComponent } from "./qr-code-viewer/qr-code-viewer.component";
import { FormRegisterComponent } from "./form-register/form-register.component";
import { EventGuard } from "../../shared/guard/event.guard";

export default [
  {
    path: "",
    canActivate: [EventGuard],
    component: QrCodeViewerComponent,
  },
  {
    path: "register",
    canActivate: [EventGuard],
    component: FormRegisterComponent,
  },
] as Routes;
